export default "__VITE_ASSET__JTnPh3m5__"